import { Link } from 'react-router-dom';
import { NavIconSupport } from '../../navigation/icons/navIcons';
import { useSupportUnreadCount } from '../hooks/useSupportUnreadCount';
import primitives from '../../../styles/primitives.module.css';
import styles from './SupportIcon.module.css';

/**
 * Header affordance for the support hub: a ghost-button icon linking to
 * /support, with an unread-ticket count badge (hidden when the count is 0).
 *
 * @param {{ token: string, t: Function }} props
 */
export const SupportIcon = ({ token, t }) => {
  const { count } = useSupportUnreadCount(token);

  return (
    <Link
      to="/support"
      className={`${primitives.ghostButton} ${styles.supportButton}`}
      aria-label={t('navSupport')}
    >
      <NavIconSupport size={20} />
      {count > 0 ? (
        <span className={`${primitives.badgeAccent} ${styles.badge}`}>{count}</span>
      ) : null}
    </Link>
  );
};
